import { useMemo } from 'react'
import { Role } from '../core/api/dto/RolesDto'

type returnType = Role

export const useDetectRoleByPath = (): returnType => {
  return useMemo(() => Role.ROLE_ADMIN, [])
}
